Vue.component('hubspot-component', {
    template: `
        <section class="embed-form-block">
            <div class="hs-form-html" data-region="eu1" :data-form-id="formId" data-portal-id="145684717"></div>
        </section>
    `,
    props: {
        formId: {
            type: String,
            required: true
        },
        portalId: {
            type: String,
            default: '145684717'
        },
        region: {
            type: String,
            default: 'eu1'
        }
    },
    data: function () {
        return {
            id: this._uid,
            form: {},
            formLoaded: false,
            loadInterval: 0,
            formRendered: false,
            formObserver: null,
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.loadInterval = setInterval(this.checkFormLoaded, 100);
        this.waitForForm();
    },
    beforeDestroy() {
        if (this.loadInterval) {
            clearInterval(this.loadInterval);
        }
        if (this.formObserver) {
            this.formObserver.disconnect();
        }
    },
    methods: {
        init: function() {
            if (!this.$root.hubspotLoaded) {
                // Load external js
                const script = document.createElement('script');
                script.src = 'https://js-eu1.hsforms.net/forms/embed/developer/145684717.js';
                script.charset = 'utf-8';
                script.type = 'text/javascript';
                document.head.appendChild(script);

                this.$root.hubspotLoaded = true;
            }
        },
        checkFormLoaded: function() {
            this.formLoaded = this.$root.hubspotLoaded;
        },
        waitForForm: function() {
            // Use MutationObserver to detect when the form is added to the DOM
            this.formObserver = new MutationObserver((mutations) => {
                const formElement = this.$el.querySelector('form');
                if (formElement && !this.formRendered) {
                    this.formObserver.disconnect();
                    // Give it a bit more time to ensure all inputs are rendered
                    setTimeout(() => {
                        this.setupInputWatchers();
                    }, 200);
                }
            });

            this.formObserver.observe(this.$el, {
                childList: true,
                subtree: true
            });
        },
        setupInputWatchers: function() {
            const formElement = this.$el.querySelector('form');

            if (!formElement) {
                console.log('No form element found');
                return;
            }

            // Get all input, textarea, and select elements
            const inputs = formElement.querySelectorAll('input:not([type="hidden"]), textarea, select');

            inputs.forEach(input => {
                // Check initial state
                this.updateInputClass(input);

                // Add event listeners
                input.addEventListener('input', () => {
                    this.updateInputClass(input);
                });
                input.addEventListener('change', () => {
                    this.updateInputClass(input);
                });
                input.addEventListener('blur', () => {
                    this.updateInputClass(input);
                });
            });

            this.formRendered = true;
            console.log('Input watchers setup complete');
        },
        updateInputClass: function(input) {
            const hasValue = input.value && input.value.trim() !== '';

            console.log('Updating class for:', input.name, 'hasValue:', hasValue, 'value:', input.value);

            if (hasValue) {
                input.classList.add('data-filled');
            } else {
                input.classList.remove('data-filled');
            }
        }
    },
    watch: {
        formLoaded: function(newVal) {
            if (newVal) {
                clearInterval(this.loadInterval);
                this.loadInterval = 0;
            }
        }
    }
});
